import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["content", "button", "icon"];

  connect() {
    console.log("Collapsible Info controller connected");
    this.isExpanded = false;
  }

  toggle(event) {
    console.log('Toggle clicked!', this.isExpanded);
    event.preventDefault();
    
    if (this.isExpanded) {
      console.log('Hiding...');
      this.hide();
    } else {
      console.log('Showing...');
      this.show();
    }
    console.log('After toggle, isExpanded:', this.isExpanded);
  }

  show() {
    this.contentTarget.style.display = 'block';
    this.contentTarget.classList.add('show');
    this.updateButtonText('Hide');
    this.updateIcon('up');
    this.isExpanded = true;
  }

  hide() {
    this.contentTarget.classList.remove('show');
    this.contentTarget.style.display = 'none';
    this.updateButtonText('Info');
    this.updateIcon('down');
    this.isExpanded = false;
  }

  updateButtonText(text) {
    const toggleText = this.buttonTarget.querySelector('.toggle-text');
    if (toggleText) {
      toggleText.textContent = text;
    }
  }
  
  updateIcon(direction) {
    if (this.hasIconTarget) {
      if (direction === 'up') {
        this.iconTarget.classList.remove('fa-chevron-down');
        this.iconTarget.classList.add('fa-chevron-up');
      } else {
        this.iconTarget.classList.remove('fa-chevron-up');
        this.iconTarget.classList.add('fa-chevron-down');
      }
    }
  }
}

